export default {
  tradeIn: {
    id: 'nav_services_trade_in',
    defaultMessage: 'Trade in',
  },
  extendedServices: {
    id: 'nav_services_extended_services',
    defaultMessage: 'Extended services',
  },
  mobilePlans: {
    id: 'nav_services_mobile_plans',
    defaultMessage: 'Mobile plans',
  },
}
